export const ApiUrl = {
    kurt: {
        blog: 'Kurt/Blog',
        isLive: 'Kurt/isLive'
    },
    contactForm: 'Contact/',
    wttr: 'https://wttr.in/?1nATFq'
}